<style scoped>
.br-10 {
  border-radius: 10px;
}
.ellipsis {
  white-space: nowrap;
  width: 250px;
  text-overflow: ellipsis;
}
</style>

<template>
  <v-container fluid>
    <div v-if="loading">
      <v-layout justify-center align-center column>
        Please wait...
        <v-progress-circular indeterminate color="primary" class="ma-3"></v-progress-circular>
      </v-layout>
    </div>
    <div v-if="!loading">
      <v-layout justify-center class="pb-3">
        <v-flex xl6 lg6 md8 sm10 xs12>
            <v-list two-line class="br-10 elevation-3 lighten-4 blue-grey--text text--darken-3" color="pink">
                <v-list-item @click="download(data[0])">
                  <v-list-item-content class="pl-2">
                    <v-card class="elevation-0 transparent title font-weight-medium">{{ $t('tutorial_1') }}</v-card>
                  </v-list-item-content>
                  <v-list-item-action class="pr-2">
                    <v-icon style="font-size: 30px;">fa-download fa-lg</v-icon>
                  </v-list-item-action>
                </v-list-item>
            </v-list>
          </v-flex>
      </v-layout>
      <v-layout justify-center class="pb-3">
        <v-flex xl6 lg6 md8 sm10 xs12>
            <v-list two-line class="br-10 elevation-3 lighten-3 black--text" color="teal">
                <v-list-item @click="download(data[1])">
                  <v-list-item-content class="pl-2">
                    <v-card class="elevation-0 transparent title font-weight-medium">{{ $t('tutorial_2') }}</v-card>
                  </v-list-item-content>
                  <v-list-item-action class="pr-2">
                    <v-icon style="font-size: 30px;">fa-download fa-lg</v-icon>
                  </v-list-item-action>
                </v-list-item>
            </v-list>
          </v-flex>
      </v-layout>
      <v-layout justify-center class="pb-3">
        <v-flex xl6 lg6 md8 sm10 xs12>
            <v-list two-line class="br-10 elevation-3 lighten-3 black--text" color="blue">
                <v-list-item @click="download(data[2])">
                  <v-list-item-content class="pl-2">
                    <v-card class="elevation-0 transparent title font-weight-medium">{{ $t('tutorial_3') }}</v-card>
                  </v-list-item-content>
                  <v-list-item-action class="pr-2">
                    <v-icon style="font-size: 30px;">fa-download fa-lg</v-icon>
                  </v-list-item-action>
                </v-list-item>
            </v-list>
          </v-flex>
      </v-layout>
      <v-layout justify-center class="pb-3">
        <v-flex xl6 lg6 md8 sm10 xs12>
            <v-list two-line class="br-10 elevation-3 lighten-3 black--text" color="indigo">
                <v-list-item @click="download(data[3])">
                  <v-list-item-content class="pl-2">
                    <v-card class="elevation-0 transparent title font-weight-medium">{{ $t('tutorial_4') }}</v-card>
                  </v-list-item-content>
                  <v-list-item-action class="pr-2">
                    <v-icon style="font-size: 30px;">fa-download fa-lg</v-icon>
                  </v-list-item-action>
                </v-list-item>
            </v-list>
          </v-flex>
      </v-layout>
    </div>
  </v-container>
</template>

<script>
import vuex from 'vuex'

export default {
  beforeMount () {
    this.fetchTutorial()
  },
  computed: {
    ...vuex.mapState({
      data: state => state.metadata.tutorial,
      loading: state => state.metadata.loading
    })
  },
  methods: {
    ...vuex.mapActions({
      fetchTutorial: 'metadata/fetchTutorial'
    }),
    download (data) {
      if (!window.hasOwnProperty('cordova')) {
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${data.title}`)
        document.body.appendChild(link)
        link.click()
        return
      }

      // mobile code start
      const storageLocation = cordova.file.externalApplicationStorageDirectory
      const fileName = data.title + '.pdf'
      var errorCallback = function (error) {
        console.log(error)
      }
      window.resolveLocalFileSystemURL(storageLocation,
        function (directory) {
          directory.getFile(fileName, {
            create: true,
            exclusive: false
          },
          function (fileEntry) {
            fileEntry.createWriter(function (writer) {
              writer.onwriteend = function () {
                cordova.plugins.fileOpener2.open(
                  storageLocation + fileName,
                  'application/pdf',
                  {
                    error: function (error) {
                      console.log('Error status: ' + error.status + ' - Error message: ' + error.message)
                    },
                    success: function () {
                      console.log('file opened successfully')
                    }
                  }
                )
              }
              writer.seek(0)
              writer.write(new Blob([data]))
            }, errorCallback)
          }, errorCallback)
        }, errorCallback)
      // mobile code end
    }
  }
}
</script>
